import { Box, Flex, Text } from "@chakra-ui/layout";
import { AnimatePresence, motion } from "framer-motion";
import { FC, useMemo } from "react";
import {Layout} from "../helpers";
import { ButtonGroupItems } from "./buttonGroupItems";
import { ButtonUngroupItems } from "./buttonUngroupItems";
import { canUngroupSelection } from "./helpers";
import {Grid, useBreakpointValue, useDisclosure} from "@chakra-ui/react";
import {ButtonActions} from "./buttonActions";
import {AssetActionsDrawer} from "domains/single-asset";
import {useDnd} from "../context";

type Props = {
  selectedAssets: any[];
  layout: Layout;
  groupItems: () => Promise<void>; 
  ungroupItems: () => Promise<void>; 
}

export const DndToolbar: FC<Props> = ({ layout, selectedAssets, groupItems, ungroupItems }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isMultipleSelected } = useDnd();
  const isMobile = useBreakpointValue([true, true, false]);

  const canUngroup = useMemo(
    () => canUngroupSelection(selectedAssets, layout),
    [ layout, selectedAssets ]
  );

  const openDrawer = (e): void => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    e.preventDefault();
    onOpen();
  }

  return (
    <>
      <AnimatePresence>
        {((selectedAssets.length > 1 ||( isMobile && selectedAssets.length > 0)) || canUngroup) && (
          <Flex
            as={motion.div}
            initial={{ opacity: 0, y: 20, x: '-50%' }}
            animate={{ opacity: 1, y: 0, x: '-50%' }}
            exit={{ opacity: 0, y: 20, x: '-50%' }}
            position="fixed"
            zIndex={1001}
            bottom="100px"
            height="60px"
            bgColor="brand.500"
            left="50%"
            transform="translateX(-50%)"
            layerStyle={[ 'with-box-shadow' ]}
            borderRadius="14px"
            flexFlow="row"
            overflow="hidden"
          >
            <Grid alignItems="center" padding="0 16px" borderRight="1px solid rgba(255,255,255,0.25)">
              <Text color="white" fontSize="sm" fontWeight="bold" textAlign={"center"} lineHeight={1.2}>
                { selectedAssets.length } {canUngroup ? 'group' : isMultipleSelected ? 'items' : 'item'} selected
              </Text>
            </Grid>

            {isMultipleSelected && (
              <Box display="flex" alignItems="center">
                {canUngroup && ( <ButtonUngroupItems ungroupItems={ungroupItems} borderRadius="0px" /> )}
                {!canUngroup && ( <ButtonGroupItems groupItems={groupItems} borderRadius="0px" />)}
              </Box>
            )}

            {(isMobile && !isMultipleSelected) && (
              <Box display="flex" alignItems="center" justifyContent="center">
                <ButtonActions onClick={openDrawer} />
              </Box>
            )}
          </Flex>
        )}
      </AnimatePresence>
      <AssetActionsDrawer
        selectedAssets={selectedAssets}
        layout={layout}
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  )
};
